import defaultSettings from '@/settings'
import {
  getList as getConfigList
} from '@/api/settings'
const {
  showSettings,
  tagsView,
  fixedHeader,
  sidebarLogo
} = defaultSettings

const state = {
  theme: "",
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  wifiModels: [],
  withdrawalMethod: 'wechat',
  withdrawalDayTimes: 2,
  withdrawalMinAmount: 1,
  withdrawalMaxAmount: 100,
  withdrawalHandMinAmount: 1000,
  aliPay: false
}

const mutations = {
  CHANGE_SETTING: (state, {
    key,
    value
  }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({
    commit
  }, data) {
    commit('CHANGE_SETTING', data)
  },
  getConfigInfo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      getConfigList().then(response => {
        const {
          data
        } = response
        if (!data) {
          reject('获取配置失败')
          return
        }
        const {
          withdrawal_method,
          withdrawal_day_times,
          withdrawal_min_amount,
          withdrawal_max_amount,
          withdrawal_hand_min_amount,
          alipay,
          wifi_model
        } = data
        commit('CHANGE_SETTING', {
          key: "withdrawalMethod",
          value: withdrawal_method
        })
        commit('CHANGE_SETTING', {
          key: "withdrawalDayTimes",
          value: withdrawal_day_times
        })
        commit('CHANGE_SETTING', {
          key: "withdrawalMinAmount",
          value: withdrawal_min_amount
        })
        commit('CHANGE_SETTING', {
          key: "withdrawalMaxAmount",
          value: withdrawal_max_amount
        })
        commit('CHANGE_SETTING', {
          key: "withdrawalHandMinAmount",
          value: withdrawal_hand_min_amount
        })
        commit('CHANGE_SETTING', {
          key: "aliPay",
          value: alipay
        })
        commit('CHANGE_SETTING', {
          key: "wifiModels",
          value: wifi_model
        })
        resolve(data)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/settings.js